import MomentUtils from '@date-io/moment';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import DefaultSettings from './settings';
import InputLabel from '@material-ui/core/InputLabel';

export default function WRSDatePicker(props) {
    const { name, options, value, handleFieldValue, edit, required, disabled, extraProps, error, helperText, contexthelp, allowedValues = [], ...otherProps } = props
    const { label, xtype, fullWidth, tooltip, FieldProps, ...otherConfigs } = otherProps;
    let val = ((value === null) || (value === undefined) || (value === '')) ? '' : value;
    const [range, setRange] = useState({})
    const [reload, setReload] = useState(false)
    let dateFormat = extraProps && extraProps.dateFormat ? extraProps.dateFormat : "MM/DD"
    val = val ? moment(val).format("MM/DD") : '';
    let currentDate = 'N';
    let pastDate = false;
    let futureDate = false;
    let currdate = false;
    let fieldprops = null;
    let fieldAllowedProps = null;
    if (FieldProps || (allowedValues && allowedValues.length === 1)) {
        fieldprops = JSON.parse(FieldProps)
        fieldAllowedProps = (allowedValues && allowedValues.length === 1) ? JSON.parse(allowedValues[0]) : null
        currentDate = (fieldprops['CurrentDefaultDate'] === true || fieldprops['CurrentDefaultDate'] === 'Y' ||
            (fieldAllowedProps && fieldAllowedProps['CurrentDefaultDate'] === 'Y')) ? 'Y' : 'N';
        if (fieldprops['AllowDate'] === 'CD') {
            pastDate = true;
            futureDate = true;
        }
        else if (fieldprops['AllowDate'] === 'PD' && currentDate == 'Y') {
            pastDate = true;
            futureDate = false;
            currdate = true;
        }
        else if (fieldprops['AllowDate'] === 'PD') {
            pastDate = true;
            futureDate = false;
        }
        else if (fieldprops['AllowDate'] === 'FD') {
            pastDate = false;
            futureDate = true;
        }
        if (currentDate === 'Y' && val === '') {
            let convertMoment = moment(new Date(), 'MM/DD').format('MM/DD')
            let events = { target: { value: convertMoment, name: name, checked: false }, currentTarget: { dataset: null } }
            handleFieldValue(events);
        }
    }
    useEffect(() => {
        if (pastDate && currdate) {
            range['maxDate'] = (new Date())
            setRange(range)
            setReload(!reload)
        }
        else if (pastDate) {
            range['maxDate'] = (val === '' ? new Date() : new Date(val))
            setRange(range)
            setReload(!reload)
        }
        else if (futureDate) {
            range['minDate'] = (val === '' ? new Date() : new Date(val));
            setRange(range)
            setReload(!reload)
        }
    }, [])


    return (
        <Fragment>
            {reload}
            <FormControl className={name} fullWidth={fullWidth ? fullWidth : true} required={required} error={error} disabled={disabled || false} >
                <InputLabel style={{ fontWeight: 'bold', color: error ? 'red' : 'black' }} shrink>{label}{tooltip &&
                    <Tooltip title={tooltip ? tooltip : null}
                        placement="bottom-start" ><HelpOutlineIcon fontSize="small" style={{ width: '0.8em', color: '#007bff', marginLeft: 5 }}
                            onClick={(evt) => contexthelp ?
                                DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
                    </Tooltip>} </InputLabel>
                <div className='pt-3'></div>
                <MuiPickersUtilsProvider utils={MomentUtils} >
                    <KeyboardDatePicker
                        disabled={disabled || false}
                        //clearable
                        error={error}
                        variant="filled"
                        InputProps={{
                            style: {
                                height: 23.5
                            }
                        }}
                        ampm={false}
                        value={((currentDate === 'Y' && !val && val != "") ? new Date() : (val === '' || val === 'Invalid date' ? null : val)) || null}
                        {...range}
                        onChange={(e) => handleFieldValue({ target: { value: e ? moment(e, dateFormat).format(dateFormat) : null, name: name, checked: false, }, currentTarget: { dataset: null } })}
                        name={name}
                        {...otherConfigs}
                        format={dateFormat}

                    />
                </MuiPickersUtilsProvider>
                {helperText && <FormHelperText>{helperText}</FormHelperText>}
            </FormControl>
        </Fragment >
    );
}